import React, { useEffect, useRef } from "react";

export default function DashboardPageBanner() {
  const adRef = useRef(null);
  const loadedRef = useRef(false);

  useEffect(() => {
    const observer = new ResizeObserver(() => {
      if (
        adRef.current &&
        adRef.current.offsetWidth > 0 &&
        !loadedRef.current
      ) {
        try {
          (window.adsbygoogle = window.adsbygoogle || []).push({});
          loadedRef.current = true;
        } catch (e) {
          console.error("AdsbyGoogle push error:", e);
        }
      }
    });

    if (adRef.current) observer.observe(adRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div className="w-full mb-6 flex justify-center">
      <ins
        className="adsbygoogle"
        ref={adRef}
        style={{ display: "block", width: "100%", height: "90px" }}
        data-ad-client="ca-pub-6063063628146000"
        data-ad-slot="7995544088"
        data-ad-format="horizontal"
        data-full-width-responsive="true"
      ></ins>
    </div>
  );
}
